import React from "react";

const StarIcon = () => (
  <svg
    width="14"
    height="13"
    viewBox="0 0 14 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.33481 0.776018C5.99939 -0.258674 7.51171 -0.258672 8.1763 0.77602L9.27829 2.49172C9.50696 2.84772 9.86095 3.10491 10.2702 3.21237L12.2424 3.73025C13.4319 4.04257 13.8992 5.48087 13.1205 6.43267L11.8293 8.01091C11.5614 8.33839 11.4262 8.75453 11.4505 9.17695L11.5674 11.2127C11.6379 12.4404 10.4144 13.3293 9.26857 12.8829L7.36858 12.1426C6.97433 11.989 6.53678 11.989 6.14253 12.1426L4.24253 12.8829C3.09669 13.3293 1.8732 12.4404 1.94372 11.2127L2.06065 9.17695C2.08491 8.75453 1.9497 8.33839 1.68178 8.01091L0.390588 6.43267C-0.388094 5.48087 0.0792394 4.04257 1.26866 3.73025L3.24092 3.21237C3.65016 3.10491 4.00415 2.84772 4.23281 2.49171L5.33481 0.776018Z"
      fill="#FFA826"
    />
  </svg>
);

export default StarIcon;
